import { renderStringToReact, useTranslation } from '@web_opxp/features';
import { FC } from 'react';
import HintPopup from '../../components/HintPopup/HintPopup';
import PredictorWidget from './PredictorWidget';

export interface IGameplaysToLevelUpProps {
  expectedRemainingGameplaysForLevelUp: number;
}

export const GameplaysToLevelUp: FC<IGameplaysToLevelUpProps> = ({ expectedRemainingGameplaysForLevelUp: amount }) => {
  const { t } = useTranslation();

  let titleId;
  let descriptionId;
  if (amount === 1) {
    titleId = 'SuccessPredictor.GameplaysToLevelUp.ShortTermSingular.Title';
    descriptionId = 'SuccessPredictor.GameplaysToLevelUp.ShortTermSingular.Description';
  } else if (amount <= 5) {
    titleId = 'SuccessPredictor.GameplaysToLevelUp.ShortTermPlural.Title';
    descriptionId = 'SuccessPredictor.GameplaysToLevelUp.ShortTermPlural.Description';
  } else if (amount <= 9) {
    titleId = 'SuccessPredictor.GameplaysToLevelUp.MidTerm.Title';
    descriptionId = 'SuccessPredictor.GameplaysToLevelUp.MidTerm.Description';
  } else {
    titleId = 'SuccessPredictor.GameplaysToLevelUp.LongTerm.Title';
    descriptionId = 'SuccessPredictor.GameplaysToLevelUp.LongTerm.Description';
  }
  const title = t(titleId, { amount });
  const description = t(descriptionId);
  const hintTitle = t('SuccessPredictor.GameplaysToLevelUp.HintTitle');
  const hintContent = t('SuccessPredictor.GameplaysToLevelUp.HintHtml');
  const hint = renderStringToReact(hintContent);
  return (
    <PredictorWidget title={title} description={description}>
      <HintPopup title={hintTitle}>{hint}</HintPopup>
    </PredictorWidget>
  );
};

export default GameplaysToLevelUp;
